import type { Doc } from '@doc';
import { Elements } from '@graph';
import type { CommandContext } from './CommandContext';

export function canDeleteSelection(context: CommandContext): boolean {
  return !context.selection.isEmpty;
}

export interface DeleteSelectionResult {
  doc: Doc;
  selection: Elements;
  hovered: Elements;
  deletedElements: Elements;
}

export function deleteSelection(
  context: CommandContext
): DeleteSelectionResult | undefined {
  if (!canDeleteSelection(context)) {
    return;
  }
  const { layouter } = context;
  let { doc, selection, hovered } = context;

  const oldDoc = doc;

  let deletedElements = Elements.make();
  try {
    doc = doc.produce('deleteSelection', draft => {
      deletedElements = draft.deleteElements(selection);
    });
    hovered = hovered.difference(deletedElements);
    doc = layouter.runIncrementalLayout(doc, oldDoc.bounds);
    selection = Elements.make();
    const result = { doc, selection, hovered, deletedElements };
    context.update(result, true);
    return result;
  } catch (e) {
    console.error(e);
    return;
  }
}
